import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  inject,
  input,
  OnInit,
  viewChild,
  DestroyRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AppFormFieldControl } from '../../form-field/form-field-control/form-field-control';
import { BaseControl } from '../base-control';
import { AppClickAreaDirective } from '../input/click-area.directive';

@Component({
  selector: 'app-check-intermediate',
  templateUrl: './check-intermediate.component.html',
  styleUrls: ['./check-intermediate.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckIntermediateComponent),
      multi: true
    },
    {
      provide: AppFormFieldControl,
      useExisting: forwardRef(() => CheckIntermediateComponent)
    }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AppClickAreaDirective, FormsModule]
})
export class CheckIntermediateComponent
  extends BaseControl<boolean>
  implements OnInit
{
  #destroyRef = inject(DestroyRef);
  private cd = inject(ChangeDetectorRef);

  public trueValue: boolean;
  public falseValue: boolean;

  readonly ngControl = viewChild(NgControl);
  readonly disableUncheck = input(false);

  public ngOnInit() {
    this.ngControl()
      .statusChanges.pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(() => this.stateChanges.next());
  }

  public writeValue(value: any) {
    this.trueValue = value === true;
    this.falseValue = value === false;
    super.writeValue(value);
  }

  public onTrueChange(value) {
    if (value) {
      this.value = value;
      this.falseValue = false;
    } else {
      this.value = null;
    }
    this.cd.detectChanges();
  }

  public onFalseChange(value) {
    if (value) {
      this.value = !value;
      this.trueValue = false;
    } else {
      this.value = null;
    }
    this.cd.detectChanges();
  }
}
